import React, { useContext } from "react";
import { WatchContext } from "../WatchContext";
import { General } from "../tools/styles";
import { sedimentAnalysis } from "../tools/sediment";
import { theme } from "../theme";
import { FaCheck, FaExclamation, FaFlag } from "react-icons/fa";

const SedimentSummary = () => {
  const { hydrosed, biosed, vertsed, horsed, sediment } =
    useContext(WatchContext);

  let sedAnal = sedimentAnalysis({ vertsed, horsed, biosed, hydrosed });

  let { redCell, yellowCell, greenCell, ruYellow, ruRed, pdeGreen } =
    theme.colors;

  let sedElems = Object.values(sedAnal).map((item, i) => {
    let testVal = JSON.stringify(item.score)
    let bgColor, icon;
    if (['[0,1]', '[1,0]'].includes(testVal)) {
      bgColor = yellowCell;
      icon = <FaExclamation color={ruYellow} />;
    } else if (testVal === '[0,0]') {
      bgColor = greenCell;
      icon = <FaCheck color={pdeGreen} />;
    } else if (testVal.includes('-1')) {
      bgColor = yellowCell;
      icon = <FaExclamation color={ruYellow} />;
    }else if (testVal === '[1,1]') {
      bgColor = redCell;
      icon = <FaFlag color={ruRed} />;
    } else {
      bgColor = 'inherit';
      
    }
    return (
      <General.RowBlock key={i} width="100%" justify="flex-start">
        <General.ColBlock
          bgColor={bgColor}
          style={{
            border: "0.5px solid black",
            borderCollapse: "collapse",
            lineHeight: "3rem",
          }}
          align="flex-start"
          justify="flex-start"
        >
          <div>
            {" "}
            <span
              style={{
                textTransform: "capitalize",
                display: "inline",
                padding: "1rem",
              }}
            >
              {icon} {item.title}( {item.variables}):
            </span>
            <span style={{ display: "inline" }}>{item.consid}</span>
          </div>
        </General.ColBlock>
      </General.RowBlock>
    );
  });

  return (
    <>
        <span>Table 2: Sediment Summary</span>
      <General.ColBlock bgColor='inherit' align="flex-start" justify="flex-start">
        {sediment.complete ? sedElems : "need more information"}
      </General.ColBlock>
      </>
  );
};

export default SedimentSummary;
